import { useState, useCallback } from 'react';

const useGenericFilter = (initialFilterState = {}, onFilterApply = () => {}, onFilterClear = () => {}) => {
  const [localFilterValues, setLocalFilterValues] = useState(initialFilterState);

  const handleFilterChange = useCallback((key, value) => {
    setLocalFilterValues(prev => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const handleSubmit = useCallback((e) => {
    e?.preventDefault?.();
    onFilterApply(localFilterValues);
  }, [localFilterValues, onFilterApply]);

  const handleClear = useCallback(() => {
    setLocalFilterValues(initialFilterState);
    onFilterClear(initialFilterState);
  }, [initialFilterState, onFilterClear]);

  return {
    localFilterValues,
    handleFilterChange,
    handleSubmit,
    handleClear
  };
};

export default useGenericFilter;